<template>
  <label :class="classList" tabindex="0">
    <template v-if="name">
      <input
        :type="type"
        :name="name"
        ref="input"
        :checked="checked"
        :value="radioValue"
        :disabled="disabled"
        @change="update" />
      <icon :name="icon" class="a-checkbox__icon" />
    </template>
    <template v-else>
      <input
        :type="type"
        ref="input"
        :checked="checked"
        :disabled="disabled"
        @change="update" />
      <icon :name="icon" class="a-checkbox__icon" />
      <div class="a-checkbox__toggle__button" v-if="subtype === 'toggle'"></div>
    </template>
  </label>
</template>

<script>
export default {
  name: 'v-checkbox',
  props: {
    name: {
      type: [String, Boolean],
      default: false,
    },
    type: {
      type: [String],
      required: true,
    },
    disabled: {
      type: [Boolean],
      default: false,
    },
    checked: {
      type: [Boolean],
      default: false,
    },
    radioValue: [String],
    value: [String, Boolean],
    subtype: [String],
    size: [String],
  },
  data() {
    return {
      icon: '',
      isChecked: false,
    };
  },
  created() {
    this.icon = this.type === 'radio' ? 'circle' : 'check';
    if (this.checked === true) {
      this.isChecked = true;
    }
  },
  computed: {
    classList() {
      const defaultClass = 'a-checkbox';
      const type = ` a-checkbox--${this.type}`;
      const size = this.size ? ` a-checkbox--${this.size}` : '';
      const subtype = this.subtype ? ` a-checkbox--${this.subtype}` : '';
      const checked = this.isChecked ? ' a-checkbox--checked' : '';
      const disabled = this.disabled ? ' a-checkbox--disabled' : '';
      return defaultClass + type + size + subtype + checked + disabled;
    },
  },
  methods: {
    update() {
      if (this.name) {
        this.$emit('input', this.$refs.input.value);
      } else {
        this.$emit('input', this.$refs.input.checked);
      }
    },
  },
  watch: {
    checked: {
      handler() {
        if (this.checked === true) {
          this.isChecked = true;
        } else {
          this.isChecked = false;
        }
      },
    },
    deep: true,
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.a-checkbox';

  $color-primary-dark: darken($signable-primary-1, 10%);

  #{$parent} {
    background: $signable-secondary-4-shade-3;
    border: 1px solid $color-border;
    display: inline-block;
    cursor: pointer;
    height: 24px;
    width: 24px;
    position: relative;
    outline: none;
    box-shadow: inset 0px 1px 5px -1px $signable-secondary-4-shade-2;
    &:hover {
      box-shadow: inset 0 1px 5px 1px $signable-secondary-4-shade-2;
    }
    //elements
    input {
      display: none;
      &:checked {
        + #{$parent}__icon {
          display: block;
        }
      }
    }
    &__icon {
      display: none;
      height: 12px;
      width: 12px;
      color: #555;
      @include alignElement(true, true);
    }
    //modifiers
    &--radio {
      border-radius: 30px;
      #{$parent}__icon {
        height: 12px;
        width: 12px;
      }
    }
    &--checkbox {
      border-radius: 3px;
    }
    &--toggle {
      min-width: 60px;
      border-radius: 30px;
      height: 28px;
      input:checked {
        + #{$parent}__icon {
          display: none;
          + #{$parent}__toggle__button {
            left: 34px;
          }
        }
      }
      #{$parent}__toggle__button {
        height: 22px;
        width: 22px;
        top: 2px;
        left: 2px;
        border: 1px solid $color-primary-dark;
        background: $signable-primary-1;
        position: absolute;
        border-radius: 30px;
        transition: left .25s ease;
      }
    }
    &--small {
      height: 20px;
      width: 20px;
      &#{$parent}--toggle {
        height: 20px;
        min-width: 40px;
        input:checked {
          + #{$parent}__icon {
            display: none;
            + #{$parent}__toggle__button {
              left: 21px;
            }
          }
        }
        #{$parent}__toggle__button {
          height: 16px;
          width: 16px;
          top: 1px;
        }
      }
    }
    &--checked {
      &#{$parent}--toggle {
        background: $color-success;
        box-shadow: inset 0 1px 5px 1px $color-success;
        border: 1px solid $color-success-dark;
        &:hover {
          box-shadow: inset 0 1px 5px 1px $color-success-dark;
        }
      }
      #{$parent}__toggle__button {
        background: #fff;
        border: 1px solid $color-success-dark;
      }
    }
    &--disabled {
      cursor: not-allowed;
      background: $signable-secondary-4-shade-3;
      #{$parent}__icon {
        color: $signable-secondary-4-shade-1;
      }
    }
  }
</style>
